module.exports = __webpack_public_path__ + "img/pc-id.b65169da.jpg";